import parseImage from './lib/parsers/parse-image';
import { getBinaryImageMetadata } from './lib/category-api/binary-image-api';
var VERSION = typeof "2.2.6" !== 'undefined' ? "2.2.6" : 'latest';
var EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'ico', 'svg'];
var MIME_TYPES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp', 'image/bmp', 'image/vndmicrosofticon', 'image/svg+xml'];
var ImageLoader = {
  id: 'image',
  name: 'Images',
  version: VERSION,
  mimeTypes: MIME_TYPES,
  extensions: EXTENSIONS,
  parse: parseImage,
  test: function test(arrayBuffer) {
    return Boolean(getBinaryImageMetadata(new DataView(arrayBuffer)));
  },
  options: {
    image: {
      type: 'auto',
      decode: true
    }
  }
};
export default ImageLoader;
//# sourceMappingURL=image-loader.js.map